import { useEffect } from "react";

import { Button, Heading, ModalDialog, Text } from "../../../elements";
import { useCookieConsent } from "../hooks";
import { CookieControlModalItems } from "./cookie-control-modal-items.component";

import styles from "./cookie-control-modal.module.css";

export function CookieControlModal() {
  const {
    routes,
    isModalOpen,
    fetchCookieConfig,
    handleSaveConsent,
    closeModal,
    pageInteraction,
    openInteraction
  } = useCookieConsent();

  useEffect(() => {
    if (isModalOpen) {
      openInteraction?.();
      fetchCookieConfig();
    }
  }, [isModalOpen, fetchCookieConfig]);

  function handleSavePreferences() {
    handleSaveConsent();
    pageInteraction?.('salvar-preferencias');
    closeModal();
  }

  return (
    <ModalDialog variant="large" isOpen={isModalOpen} onClose={closeModal}>
      <ModalDialog.Header>
        <Heading>Uso de Cookies</Heading>
      </ModalDialog.Header>
      <ModalDialog.Body>
        <Text>
          Os Cookies são pequenos arquivos que ajustam a sua navegação pra que
          você tenha a melhor experiência dentro da Webmotors, assim como os
          ajustes que você faz no carro pra dirigir com conforto e segurança. ;)
          Saiba mais na nossa{" "}
          <Text
            className={styles.Link}
            as="a"
            variant="body-bold-small"
            target="_blank"
            href={routes.INSTITUTIONAL.PRIVACY}
            data-qa="cookie-control-institutional_privacy"
          >
            Política de privacidade
          </Text>{" "}
          e{" "}
          <Text
            className={styles.Link}
            as="a"
            variant="body-bold-small"
            target="_blank"
            href={routes.INSTITUTIONAL.COOKIE_POLICY}
            data-qa="cookie-control-institutional_cookie_privacy"
          >
            Política de Cookies
          </Text>
          .
        </Text>
        <Text className={styles.Text}>
          Defina os tipos de Cookies que podemos usar:
        </Text>
        <CookieControlModalItems />
      </ModalDialog.Body>
      <ModalDialog.Footer className={styles.Footer}>
        <Button
          className={styles.Button}
          onClick={handleSavePreferences}
          data-qa="cookie-control-save_preferences"
        >
          Salvar Preferencias
        </Button>
      </ModalDialog.Footer>
    </ModalDialog>
  );
}
